/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EmployeePostViewModel } from "../types/EmployeePostViewModel.ts";

export const employeePostViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  description: z.string().nullish(),
  shortName: z.string().nullish(),
  companyId: z.number().int().nullish(),
  companyName: z.string().nullish(),
  parentEmployeePostId: z.number().int().nullish(),
  parentEmployeePostName: z.string().nullish(),
  companyDefault: z.optional(z.boolean()),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<EmployeePostViewModel>;
